<template>
  <div class="PointsFor">
    <header-box />
    <div class="Points">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="已发货" name="1">
          <el-table :data="orderList" height="50vh" stripe style="width: 100%">
            <el-table-column>
              <template slot-scope="scope">
                <div style="text-align: center">
                  <img
                    style="width: 60px"
                    :src="
                      scope.row.OrderGoodsDtos[0].GoodsDto.ImgDtos[0].ImgUrl
                    "
                    alt=""
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品名称">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.OrderGoodsDtos[0].GoodsDto.GoodsName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <div>{{ scope.row.OrderGoodsDtos[0].Quantity }}</div>
              </template>
            </el-table-column>
            <el-table-column label="积分">
              <template slot-scope="scope">
                <div style="color: #f00">{{ scope.row.OldAmount }}积分</div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="未发货" name="2">
          <el-table :data="orderList" height="50vh" stripe style="width: 100%">
            <el-table-column>
              <template slot-scope="scope">
                <div style="text-align: center">
                  <img
                    style="width: 60px"
                    :src="
                      scope.row.OrderGoodsDtos[0].GoodsDto.ImgDtos[0].ImgUrl
                    "
                    alt=""
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品名称">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.OrderGoodsDtos[0].GoodsDto.GoodsName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <div>{{ scope.row.OrderGoodsDtos[0].Quantity }}</div>
              </template>
            </el-table-column>
            <el-table-column label="积分">
              <template slot-scope="scope">
                <div style="color: #f00">{{ scope.row.OldAmount }}积分</div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="已完成" name="3">
          <el-table :data="orderList" height="50vh" stripe style="width: 100%">
            <el-table-column>
              <template slot-scope="scope">
                <div style="text-align: center">
                  <img
                    style="width: 60px"
                    :src="
                      scope.row.OrderGoodsDtos[0].GoodsDto.ImgDtos[0].ImgUrl
                    "
                    alt=""
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品名称">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.OrderGoodsDtos[0].GoodsDto.GoodsName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <div>{{ scope.row.OrderGoodsDtos[0].Quantity }}</div>
              </template>
            </el-table-column>
            <el-table-column label="积分">
              <template slot-scope="scope">
                <div style="color: #f00">{{ scope.row.OldAmount }}积分</div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <div class="felxBtn">
          <button @click="previousClick">上一页</button>
          <button @click="nextClick">下一页</button>
        </div>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import headerBox from "../../components/box/headerbox.vue";
import { getOrderApi } from "../../api/http/order";

export default {
  components: {
    headerBox,
  },
  data() {
    return {
      activeName: "2",
      orderList: [], //订单循环
      params: {
        page: 1,
        size: 10,
        orderType: 1,
        orderTypes: 1,
        stategroup: 1,
      },
    };
  },
  created() {
    this.getOrderList();
  },
  methods: {
    //   下一页
    nextClick() {
      if (this.orderList.length == 0) {
        this.$message({
          message: "已经是最后一页了",
          type: "success",
        });
      } else {
        this.params.page++;
      }
      this.getOrderList();
    },
    //   上一页
    previousClick() {
      if (this.params.page > 0) {
        this.params.page--;
      } else {
        this.params.page = 1;
        return this.$message({
          message: "这已是第一页",
          type: "success",
        });
      }
      this.getOrderList();
    },
    //   请求数据
    getOrderList() {
      getOrderApi.getOrderLlist(this.params).then((res) => {
        if (res.data.code == 200) {
          this.orderList = res.data.data;
        }
      });
    },
    //   头部变化
    handleClick(tab, event) {
      if (this.activeName == "1") {
        this.params = {
          page: 1,
          size: 10,
          orderType: 1,
          orderTypes: 1,
          stategroup: 2,
        };
      } else if (this.activeName == "2") {
        this.params = {
          page: 1,
        size: 10,
        orderType: 1,
        orderTypes: 1,
        stategroup: 1,
        };
      } else if (this.activeName == "3") {
        this.params = {
          page: 1,
          size: 10,
          orderType: 1,
          orderTypes: 1,
          states: 7,
        };
      }
       this.getOrderList()
    },
  },
};
</script>
<style lang="scss" scoped>
.felxBtn {
  display: flex;
  justify-content: center;
  button {
    margin: 1rem;
  }
}
.Points {
  width: 90%;
  margin: auto;
  margin-top: 1rem;
  border: 1px solid #999;
}
</style>


// WEBPACK FOOTER //
// src/view/my/PointsFor.vue